import md5 from 'js-md5'
import cryptoJs from 'crypto-js'
let signKey = ''
let signVal = ''
if (process.env.NODE_ENV === 'production') {
  signKey = 'htsk_hxg_client'
  signVal = 'Htskxzjs1'
} else {
  signKey = 'htsk_client'
  signVal = 'htsk_secret'
}
export function getwaySign(config) {
  const url = config.url
  const signObj = {
    method: url,
    client_id: signKey,
    sign_method: 'md5',
    timestamp: getNowFormatDate()
  }
  const { paramsStr, signStr } = sort_ASCCII(signObj)
  const newsignStr = `${signVal}${signStr}${signVal}`
  const sign = md5(newsignStr).toUpperCase()
  return encodeURI(`${paramsStr}sign=${sign}`)
}
// ascii 排序
function sort_ASCCII(obj) {
  const keyArr = Object.keys(obj).sort()
  const newObj = {}
  let signStr = ''
  let paramsStr = ''
  keyArr.forEach(item => {
    newObj[item] = obj[item]
    paramsStr += `${item}=${obj[item]}&`
    signStr += `${item}${obj[item]}`
  })

  return { paramsStr, signStr }
}
function getNowFormatDate() {
  var date = new Date()
  var seperator1 = '-'

  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var hour = date.getHours()
  var minutes = date.getMinutes()
  var seconds = date.getSeconds()
  var strDate = date.getDate()

  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate + ' ' + hour + ':' + minutes + ':' + seconds

  return currentdate
}
// get brower
export function GetCurrentBrowser() {
  const ua = navigator.userAgent.toLocaleLowerCase()
  let browserType = null
  if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
    browserType = 'IE'
  } else if (ua.match(/firefox/) != null) {
    browserType = 'firefox'
  } else if (ua.match(/ucbrowser/) != null) {
    browserType = 'UC'
  } else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
    browserType = 'opera'
  } else if (ua.match(/bidubrowser/) != null) {
    browserType = 'baidu'
  } else if (ua.match(/metasr/) != null) {
    browserType = 'sougou'
  } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
    browserType = 'QQ'
  } else if (ua.match(/maxthon/) != null) {
    browserType = 'maxthon'
  } else if (ua.match(/chrome/) != null) {
    var is360 = _mime('type', 'application/vnd.chromium.remoting-viewer')
    if (is360) {
      browserType = '360'
    } else {
      browserType = 'chrome'
    }
  } else if (ua.match(/safari/) != null) {
    browserType = 'Safari'
  } else {
    browserType = 'others'
  }
  return browserType
}

// DES加密
export const encryptDes = (message, key) => {
    var keyHex = cryptoJs.enc.Utf8.parse('HyAzdTF%PIjHlm+jhu&9')
    var encrypted = cryptoJs.DES.encrypt(message, keyHex, {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7
    })
    return encrypted.toString()
  }
  
  // DES解密
  export const decryptDes = (message, key) => {
    var keyHex = cryptoJs.enc.Utf8.parse(key)
    var decrypted = cryptoJs.DES.decrypt(
      {
        ciphertext: cryptoJs.enc.Hex.parse(message)
      },
      keyHex,
      {
        mode: cryptoJs.mode.ECB,
        padding: cryptoJs.pad.Pkcs7
      }
    )
    return decrypted.toString(cryptoJs.enc.Utf8)
  }
  
  // 字符串转16进制
  export function strToHexCharCode(str) {
    if (str === '') { return '' }
    var hexCharCode = []
    // hexCharCode.push('0x')
    for (var i = 0; i < str.length; i++) {
      hexCharCode.push((str.charCodeAt(i)).toString(16))
    }
    return hexCharCode.join('')
  }

function _mime(option, value) {
  var mimeTypes = navigator.mimeTypes
  for (var mt in mimeTypes) {
    if (mimeTypes[mt][option] === value) {
      return true
    }
  }
  return false
}
